;(function () {
  const components = {
    header: SAXX.Init.Component((node) => {
      const parent = node.parentNode
      const sectionHeight = () => node.offsetHeight
      const sectionRect = () => parent.getBoundingClientRect()
      const bodyRect = () => document.body.getBoundingClientRect()

      const setSpacerVariable = () => {
        document
          .querySelector(':root')
          .style.setProperty('--header-space', `${sectionHeight() / 16}rem`)
      }

      let lastScrollDepth = 0

      const setHeaderSlideAwayState = () => {
        setSpacerVariable()
        const scrollDepth = window.scrollY

        const sectionTop = sectionRect().top - bodyRect().top
        const sectionBottom =
          sectionRect().bottom - bodyRect().top + sectionHeight()

        if (
          scrollDepth < lastScrollDepth &&
          (scrollDepth <= sectionTop || scrollDepth <= 10)
        ) {
          node.classList.remove('fixed', 'scroll-up')
          parent.classList.remove('needs-spacer')
        } else if (
          scrollDepth > lastScrollDepth &&
          scrollDepth > sectionBottom
        ) {
          node.classList.add('fixed')
          parent.classList.add('needs-spacer')
        }

        parent.classList.toggle(
          'elements-should-offset',
          scrollDepth < lastScrollDepth,
        )
        node.classList.toggle('scroll-up', scrollDepth < lastScrollDepth)

        lastScrollDepth = scrollDepth
      }

      setSpacerVariable()

      window.addEventListener(
        'resize',
        SAXX.Library.Debounce(setHeaderSlideAwayState, 100),
      )

      window.addEventListener(
        'scroll',
        SAXX.Library.Throttle(setHeaderSlideAwayState, 25),
      )
    }),
    cartNavigationIcon: SAXX.Init.Component((node, ctx) => {
      ctx.on(
        SAXX.Events.CartUpdated,
        (
          _,
          { cart = {}, addedLineItems } = { cart: {}, addedLineItems: null },
        ) => {
          const cartLineItems = addedLineItems ?? cart.items ?? []

          node.classList.toggle('cart-has-items', cartLineItems.length > 0)
        },
      )
    }),
  }

  Object.assign(SAXX.Init.Components, components)

  SAXX.Init.Callbacks.push(() => {
    return () => {
      const setStickyTopOffset = () => {
        const offset = document.getElementById('header').clientHeight / 16
        document
          .querySelector(':root')
          .style.setProperty('--sticky-top-offset', `${offset}rem`)
      }

      setStickyTopOffset()

      window.addEventListener(
        'resize',
        SAXX.Library.Debounce(setStickyTopOffset, 100),
      )
    }
  })
})()
